import {
  DollarCircleOutlined,
  FundOutlined,
  HistoryOutlined,
  MailOutlined,
  SlidersOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useAppDispatch } from '@core/redux/hooks';
import { updateBreadcrumbs } from '@features/layout/store/layout.slice';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { TabComponentProps } from 'src/app/components/antd/TabComponent';

import { customerApi } from '../api/customerApi';

const CUSTOMER_TABS_OPTIONS: TabComponentProps['tabList'] = [
  { title: 'Resumo do Cliente', icon: <UserOutlined /> },
  { title: 'Comunicações', icon: <MailOutlined /> },
  { title: 'Financeiro', icon: <DollarCircleOutlined /> },
  { title: 'Uso e engajamento', icon: <FundOutlined /> },
  { title: 'Ações', icon: <SlidersOutlined /> },
  { title: 'Histórico', icon: <HistoryOutlined /> },
];

export const useCustomerDetails = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [tabActive, setTabActive] = useState<string>('0');

  const { id } = useParams<{ id: string }>();
  const [searchParam, setSearchParam] = useState(id);
  const {
    data: customerData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['customer', searchParam],
    queryFn: () => customerApi.fetchCustomerData(searchParam),
    enabled: !!searchParam,
    refetchOnWindowFocus: false,
  });
  const [customerExists, setCustomerExists] = useState(false);

  const replaceUrlCustomerId = (newId: string) => {
    navigate(`/cliente/${newId}`, { replace: true });
  };

  const handleSearchCustomer = (newSearchParam: string) => {
    setSearchParam(newSearchParam);
  };

  useEffect(() => {
    if (!customerData && !isLoading) {
      setCustomerExists(false);
      dispatch(
        updateBreadcrumbs([
          {
            label: 'Clientes',
            route: '/clientes',
          },
          { label: 'Cliente não encontrado' },
        ])
      );
    }

    if (customerData) {
      const { customer } = customerData;
      replaceUrlCustomerId(customer.id);
      setCustomerExists(true);
      dispatch(
        updateBreadcrumbs([
          {
            label: 'Clientes',
            route: '/clientes',
          },
          { label: customer.name },
        ])
      );
    }
  }, [customerData, isLoading]);

  return {
    tabActive,
    setTabActive,
    tabList: CUSTOMER_TABS_OPTIONS,
    customerData,
    customerExists,
    handleSearchCustomer,
    isLoading,
    isError,
  };
};
